<template>
  <el-row class="building-container">
    <el-col :span="24"
            class="mb-15">
      <el-button v-has="'/area/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <!-- <el-button type="primary"
                 @click="multipleDelete">批量删除</el-button> -->
    </el-col>
    <el-col :span="12"
            :xs="24">
      <el-card shadow="none">
        <el-tree highlight-current
                 default-expand-all
                 show-checkbox
                 node-key="id"
                 :expand-on-click-node="false"
                 :data="treeData"
                 :props="defaultProps">
          <span class="custom-tree-node"
                slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-link v-has="'/area/add'"
                       class="mr-10"
                       type="primary"
                       icon="el-icon-circle-plus-outline"
                       @click="() => handleAdd(data)"></el-link>
              <el-link v-has="'/area/edit'"
                       class="mr-10"
                       type="primary"
                       icon="el-icon-edit"
                       @click="() => handleEdit(data)"></el-link>
              <el-link v-has="'/area/del'"
                       type="danger"
                       icon="el-icon-delete"
                       @click="() => handleDelete(data)"></el-link>
            </span>
          </span>
        </el-tree>
      </el-card>
    </el-col>
    <add-building v-if="showBuildingModal"
                  :isShow="showBuildingModal"
                  :data="buildingData"
                  @handleClose="closeBuildingModal"></add-building>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddBuilding from '@/views/basic/building/AddBuilding'
export default {
  components: { AddBuilding },
  data() {
    return {
      searchForm: {
        keyword: '',
        status: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treeData: [],
      // 添加机构相关
      showBuildingModal: false,
      buildingData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      fetch.getAreaTreeManage({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.treeData = data.treeData
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 添加机构
    handleAdd(data) {
      this.showBuildingModal = true
      this.buildingData = {
        type: 'add',
        id: data ? data.id : ''
      }
    },
    closeBuildingModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showBuildingModal = false
    },
    // 批量删除
    multipleDelete() {
      console.log(this.$refs.personTree.getCheckedKeys())
    },
    // 编辑
    handleEdit(data) {
      this.showBuildingModal = true
      this.buildingData = {
        type: 'edit',
        id: data.id
      }
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delArea({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
.building-container {
  .el-tree-node__content {
    height: 36px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
